// Shared text helpers (June 2026 — dropdown long-name usability fix)
export const truncateLabel = (s, n = 48) => {
  const str = String(s || '');
  return str.length > n ? `${str.slice(0, n - 1).trimEnd()}…` : str;
};
